export default __webpack_public_path__ + "static/media/logo-us-macy.dccd74fa.svg";